<template>
  <div id="app">
    <router-view/>
    <!--<footer style="text-align: center;">-->
    <!--<div style="width:300px;margin:0 auto; padding:20px 0;text-align: center;left: 50%;bottom: 0;">-->
	     <!--<a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../static/footImg.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44060402000992号</p ></a >-->
	    <!--</div>-->
    <!--</footer>-->
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import "./global/css/reset.css";
import Vue from 'vue';
export default {
  computed:{
    ...mapState(["user", "department", "token"]),
  },
  mounted(){
    // window.localStorage.removeItem("wxCode");
    window.localStorage.removeItem("isLogin");
  },
  methods: {
    ...mapMutations(["SET_USER","SET_TOKEN","SET_DEPART"])
  },
  mounted(){
  	var footer = document.getElementsByTagName("footer")[0];
  	if(this.$route.path.indexOf("login") != -1 ){
    	footer.style.position = "absolute";
    	footer.style.textAlign = "center";
    	footer.style.width = "100%";
    	footer.style.bottom = "0";
  	}
  },
  watch:{      
    $route( to , from ){ 
  		var footer = document.getElementsByTagName("footer")[0];
    	if(to.path.indexOf("login") == -1){
    			footer.style.position = "static";
		    	footer.style.textAlign = "center";
		    	footer.style.width = "auto";
		    	footer.style.bottom = "0";
    	}else{
    		footer.style.position = "absolute";
	    	footer.style.textAlign = "center";
	    	footer.style.width = "100%";
	    	footer.style.bottom = "0";
    	}
    	if(from.path.indexOf("wx") != -1 && to.path.indexOf("defa") != -1){
    		window.localStorage.setItem("haveC",true);
    		this.$router.push(from.path);
    	}else{
    		window.localStorage.setItem("haveC",false);
    	}
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue